export default __webpack_public_path__ + "static/media/detail_mobile_4_2.d127f64a.png";